import { Box, ListView } from '@razorpay/blade/components';
import React, { useEffect, useState } from 'react';
import { PerquisitesDetailView, PerquisitesListView } from './index';
import { PerquisitesFilters } from 'components/SalaryComponents/components/filters';
import { StatusFilterKeyType } from 'components/SalaryComponents/components/filters/StatusFilter';
import { useQuery } from 'react-query';
import listPerquisitesComponents from 'api/gql-utils/perquisitesComponents/listPerquisitesComponents';
import { useFilters } from 'hooks/useFilters';
import { PerquisiteComponentStatus } from 'api/gql-utils/perquisitesComponents/types';

const PerquisitesView = () => {
  const { currentFilters } = useFilters({
    filtersMap: {
      status: 'status',
    },
  });

  const perquisiteStatusMap: Record<string, PerquisiteComponentStatus> = {
    active: 'active',
    disabled: 'inactive',
  };

  const { data, isError, isFetching, isRefetching, refetch } = useQuery({
    queryKey: [listPerquisitesComponents, { status: perquisiteStatusMap[currentFilters.status] }],
    queryFn: () =>
      listPerquisitesComponents({
        status: perquisiteStatusMap[currentFilters.status],
      }),
    select(data) {
      return data?.payrollListPerquisiteComponents?.components;
    },
    onError(err) {
      console.log('Error', err);
    },
  });

  const nodes = data ?? [];

  // Calculate counts directly in the parent
  const [counts, setCounts] = useState<Record<StatusFilterKeyType, number>>({
    all: 0,
    active: 0,
    disabled: 0,
  });
  useEffect(() => {
    if (nodes.length > 0 && !isFetching && counts.all === 0) {
      setCounts({
        all: nodes.length,
        active: nodes.filter((node) => node.status === 'active').length,
        disabled: nodes.filter((node) => node.status === 'inactive').length,
      });
    }
  }, [nodes, isFetching, counts]);

  return (
    <Box paddingX="spacing.8" marginTop="spacing.5">
      <ListView>
        <PerquisitesFilters counts={counts} />
        <PerquisitesListView
          data={nodes || []}
          isLoading={isFetching}
          isError={isError}
          isRefreshing={isRefetching}
          refetch={refetch}
        />
      </ListView>
      <PerquisitesDetailView />
    </Box>
  );
};

export default PerquisitesView;
